import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react"
import { useRouteMatch } from "react-router"
import Grid from "../../../components/Grid/Grid"
import SelectItem from "../../../components/Grid/SelectItem"
import Loader from "../../../components/Loader/Loader"
import { iArTarget, iArTargetQuery } from "../../../definitions/ArTarget"
import { iChangeValueProps, iUrlParams } from "../../../definitions/interfaces"
import { useData } from "../../../hooks/useData"
import ArTargetItem from "../../ArTargets/Item"

const ManageArTargets: FunctionComponent<iChangeValueProps> = ({
  onChange,
}) => {
  const match = useRouteMatch<iUrlParams>()

  const { data } = useData<iArTargetQuery, iArTarget>({
    link: "/v2/exhibitions/" + match.params.url + "/ar-targets",
    defaultQuery: {},
    shouldPingForData: false,
  })

  const [selected, setSelected] = useState<iArTarget[]>(data)
  const _selected = useRef<iArTarget[]>(data)

  useEffect(() => {
    setSelected(data)
    _selected.current = data
  }, [data])

  const { data: targets, loading } = useData<iArTargetQuery, iArTarget>({
    link: "/v1/ar-targets",
    defaultQuery: {},
    shouldPingForData: false,
  })

  const handleClick = useCallback(
    (target: iArTarget) => {
      if (_selected.current.find((a) => a._id === target._id)) {
        _selected.current = _selected.current.filter(
          (a) => a._id !== target._id,
        )
      } else {
        _selected.current = [..._selected.current, target]
      }

      setSelected(_selected.current)
      onChange && onChange(_selected.current.map((at) => at._id))
    },
    [setSelected],
  )

  const handleRemove = useCallback(
    (target: iArTarget) => {
      const tmp = _selected.current.filter((a) => a._id !== target._id)
      _selected.current = tmp
      setSelected(tmp)
      onChange && onChange(tmp.map((target) => target._id))
    },
    [setSelected],
  )

  return (
    <>
      <div className="content-header">
        {/* <AssetFilters query={query} setQuery={setQuery} /> */}
      </div>
      <div className="flex-grids">
        <div className="col-6 grid-wrap">
          <label>Select ar targets</label>
          {loading ? (
            <Loader />
          ) : (
            <Grid>
              {targets.map((target) => (
                <SelectItem<iArTarget>
                  key={target._id}
                  item={target}
                  isSelected={!!selected.find(({ _id }) => _id === target._id)}
                  onClick={handleClick}
                >
                  <ArTargetItem {...target} />
                </SelectItem>
              ))}
            </Grid>
          )}
        </div>
        <div className="grid-separator"></div>
        <div className="col-6 grid-wrap selected-wrap">
          <label>Selected ar targets</label>
          <Grid>
            {selected.map((target) => (
              <SelectItem<iArTarget>
                key={target._id}
                item={target}
                isSelected={false}
                onClick={handleRemove}
              >
                <ArTargetItem {...target} />
              </SelectItem>
            ))}
          </Grid>
        </div>
      </div>
    </>
  )
}

export default ManageArTargets
